import React, { useId } from 'react'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import { AnimableItem, AnimatedProps } from './_props'

const Animated = ({
    transitionName,
    appear = false,
    transitionLeaveTimeout = 200,
    transitionEnterTimeout = 200,
    enter,
    exit,
    items,
}: AnimatedProps) => {
    const randomId = useId()

    const AnimableItems = items.map((item, i) => {
        const animable: AnimableItem = {
            item,
            id: `${randomId}-animable-${i}`,
        }

        return animable
    })

    return (
        <TransitionGroup>
            {AnimableItems.map(({ item, id }) => (
                <CSSTransition
                    key={id}
                    classNames={transitionName}
                    appear={appear}
                    enter={enter}
                    exit={exit}
                    timeout={{ exit: transitionEnterTimeout, enter: transitionLeaveTimeout }}
                >
                    {item}
                </CSSTransition>
            ))}
        </TransitionGroup>
    )
}

export default Animated
